import ctl from '@netlify/classnames-template-literals';

export const containerStyle = ctl(`
  w-full 
  mb-5
`);
